import { logout } from "@store/reducers/auth";
import Alert from "assets/svg/student/alert-exit.svg";
import { useRouter } from "next/router";
import React, { FC } from "react";
import { useQueryClient } from "react-query";
import { useDispatch } from "react-redux";

import { Button } from "..";
import Modal from "./Modal";

type Props = {
  isShowModal: boolean;
  setIsShowModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const ExitModal: FC<Props> = ({ isShowModal, setIsShowModal }) => {
  const query = useQueryClient();
  const dispatch = useDispatch();

  const clearCookies = async () => {
    await dispatch(logout(""));
    await setIsShowModal(false);
    await query.invalidateQueries();
  };

  const handleExit = () => {
    clearCookies().then(() => {
      window.location.replace("/");
    });
  };

  return (
    <Modal
      visible={isShowModal}
      onClose={() => setIsShowModal(false)}
      className="h-screen w-screen"
    >
      <div className="relative mx-auto grid h-40 w-10/12 grid-cols-1 justify-between rounded bg-white py-6 px-4 md:h-[189px] md:w-[418px] md:p-[30px] xl:h-[189px]">
        <div className="flex gap-x-4">
          <Alert />
          <p className="self-center whitespace-nowrap text-xs md:text-base">
            از بستن حساب کاربری خود مطمئن هستید؟
          </p>
        </div>
        <div className="grid grid-cols-2 gap-x-2 text-white">
          <Button
            onClick={() => setIsShowModal(false)}
            className="w-full rounded bg-[#B8B7B7] py-2 transition-all hover:ring-2"
          >
            خیر
          </Button>
          <Button
            onClick={handleExit}
            className="w-full rounded bg-[#2747AB] py-2 transition-all hover:ring-2"
          >
            بله
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ExitModal;
